module.exports = __webpack_public_path__ + "static/media/react-native.64079c42.jpeg";